import React from 'react'
import { withAuthenticationRequired } from '@auth0/auth0-react'
import Dashboard from '../Dashboard'

const ProtectedDashboard = () => {
  return <Dashboard />
}

export default withAuthenticationRequired(ProtectedDashboard, {
  onRedirecting: () => <div>Loading Session...</div>,
})
